// Animation utilities for splash screen
// Based on splash-scene.jsx motion system

export const easings = {
  easeOutCubic: (t) => 1 - Math.pow(1 - t, 3),
  easeInQuad: (t) => t * t,
  easeInOutCubic: (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2,
};

export const animate = ({ from, to, start, end, ease }) => (currentTime) => {
  if (currentTime < start) return from;
  if (currentTime >= end) return to;
  const progress = (currentTime - start) / (end - start);
  const eased = ease(progress);
  return from + (to - from) * eased;
};

export const MOTION = {
  enter: (T, s, e, dist = 24) => ({
    opacity: animate({ from: 0, to: 1, start: s, end: e, ease: easings.easeOutCubic })(T),
    ty: animate({ from: dist, to: 0, start: s, end: e, ease: easings.easeOutCubic })(T),
  }),
  exit: (T, s, e, dist = -18) => ({
    opacity: animate({ from: 1, to: 0, start: s, end: e, ease: easings.easeInQuad })(T),
    ty: animate({ from: 0, to: dist, start: s, end: e, ease: easings.easeInQuad })(T),
  }),
  glide: (T, s, e, from, to) =>
    animate({ from, to, start: s, end: e, ease: easings.easeInOutCubic })(T),
};
